import { Tooltip } from "antd";
import "./style.css";

const UITooltip = (props: any) => {
  const { title, color, children, placement, overlayStyle, getPopupContainer } = props;
  return (
    <>
          <Tooltip
            title={title}
            color={color}
            placement={placement}
            overlayStyle={overlayStyle}
            getPopupContainer={getPopupContainer}
            mouseEnterDelay={0.3}
            mouseLeaveDelay={0.1}
          >
            {children}
          </Tooltip>
    </>
  );
};

export default UITooltip;
